import { createContext } from 'react'

import type { FlowLogger } from './createFlowLogger'

export const FlowLoggerContext = createContext<FlowLogger | null>(null)
